<div [formGroup]="formGroup" class="form-group {{ ctrl?.StyleText }}" [class.has-error]="!isValid(formGroup, ctrl)"
  [libCtrConfigUI]="ctrl" [altura]="ctrl?.Altura" [isMobile]="isMobile">

  <label *ngIf="!isUrl" [id]="getId(ctrl)" [libStudioLayout]="ctrl" [isMobile]="isMobile"
    [class.black]="enTheme === 'black'">{{ ctrl?.ValorTexto }}</label>

  <a *ngIf="isUrl" target="_blank" [libStudioLayout]="ctrl" [href]="ctrl?.ValorTexto"
    [isMobile]="isMobile">{{ ctrl?.ValorTexto }}</a>

</div>